import { netsuiteIntegrationSelectors } from '@vy/app-selectors';
import type { FC } from 'react';
import type { Control } from 'react-hook-form';
import { useNetSuiteConnect } from '../../../../../../../hooks/requests/integrations';
import { IntegrationFooter } from '../../../components/IntegrationFooter';
import type { NetSuiteRegisterFormValues } from '../NetsuiteRegisterFormSchema';

type NetSuiteFooterProps = {
  control: Control<NetSuiteRegisterFormValues>;
};

export const NetSuiteFooter: FC<NetSuiteFooterProps> = ({ control }) => {
  const mutateAsyncNetSuiteConnect = useNetSuiteConnect();

  return (
    <div data-vy={netsuiteIntegrationSelectors.registration.connectButton}>
      <IntegrationFooter
        control={control}
        mutate={mutateAsyncNetSuiteConnect}
        buttonLabel="Connect to NetSuite"
        toastMessages={{
          pending: 'Connecting...',
          success: 'Connected',
          error: 'Failed to connect',
        }}
      />
    </div>
  );
};
